// React imports.
import React, { Component, } from "react";

// App imports.
import { AppPagesEnum, BreadCrumbsCurrentStepEnum } from "../state";
import { createState } from "../state";
import StartPage from "./StartPage";
import StandardReports from "./StandardReports";
import SelectReport from "./SelectReport";
import ChooseStates from "./ChooseStates";
import ChooseYears from "./ChooseYears";

class BaseLayout extends Component {
     state = createState(this);
     /**
      * Render().
      */
     render() {
          return (
               <div>
                    <div className={"row"}>
                         <div className={"col-md-12 title-bar"}>
                              <div className={"d-flex bd-highlight"}>
                                   <div className={"mr-auto px-2 bd-highlight"}>
                                        <h2>{this.state.getHeaderText()}</h2>
                                   </div>
                                   <div className={"p-2 bd-highlight"}>
                                        <a href="/data_warehouse/doc/LIHEAP_PM_Glossary.pdf" >LIHEAP Glossary</a>
                                   </div>
                                   <div className={"p-2 bd-highlight"}>
                                        <a href="/data-warehouse-help" >Reports Help</a>
                                   </div>
                                   <div className={"p-2 bd-highlight"}>
                                        <a href="/data-feedback">Site Feedback</a>
                                   </div>
                              </div>
                         </div>
                    </div>

                    {/*----------------------------
                    * Display error message
                    * ----------------------------*/}
                    {this.state.ShowSpinner == true
                         && <img src="/data_warehouse/images/spinner-small.gif" alt="Image to show that page is loading" className="spinner" style={{ padding: 20, }} />
                    }
                    {(this.state.ErrorMessage !== '')
                         && <span className="errorMessageText"><br /><br />{this.state.ErrorMessage}<br /><br /></span>
                    }
                    {/*----------------------------*/}

                    {this.state.CurrentAppPage === AppPagesEnum.StartPage
                         && <StartPage state={this.state} />}
                    {this.state.CurrentAppPage === AppPagesEnum.StandardReports
                         && <StandardReports state={this.state} />}
                    {this.state.CurrentAppPage === AppPagesEnum.SelectReport
                         && <SelectReport
                              breadCrumbsCurrentStep={BreadCrumbsCurrentStepEnum.Topics}
                              reportCategories={this.state.ReportCategoriesForSelectedType}
                              reportSelectedHander={this.state.reportSelectedHandler}
                         />
                    }
                    {this.state.CurrentAppPage === AppPagesEnum.ChooseStates
                         && <ChooseStates
                              breadCrumbsCurrentStep={BreadCrumbsCurrentStepEnum.States}
                              state={this.state} />}
                    {this.state.CurrentAppPage === AppPagesEnum.ChooseYears
                         && <ChooseYears breadCrumbsCurrentStep={BreadCrumbsCurrentStepEnum.Years}
                              state={this.state}
                         />}

                    <div style={{ "clear": "both" }}>
                         {(this.state.CurrentAppPage === AppPagesEnum.SelectReport
                              || this.state.CurrentAppPage === AppPagesEnum.ChooseStates
                              || this.state.CurrentAppPage === AppPagesEnum.ChooseYears)
                              &&
                              <button className="dataButton " onClick={this.state.backToStandardReports}>Back to standard reports</button>
                         }
                         {(this.state.CurrentAppPage === AppPagesEnum.StandardReports
                              ||this.state.CurrentAppPage === AppPagesEnum.SelectReport
                              || this.state.CurrentAppPage === AppPagesEnum.ChooseStates
                              || this.state.CurrentAppPage === AppPagesEnum.ChooseYears)
                              &&
                              <button className="dataButton " onClick={this.state.backToStart}>Back to start</button>
                         }
                    </div>
               </div>
          );
     }

}
export default BaseLayout;
